module.exports = __webpack_public_path__ + "static/perfect-for-busy-life-43901f64c8c0c52bf657a398f7d2f610.webp";